<template>
  <BaseFieldWrapper
    v-bind="{...$props, ...$attrs}"
    v-on="$listeners"
  
    v-slot="{vuelidateIns, value, listeners, attrs}"
  >
    <textarea ref="input"
      :value="value"
      :class="[vuelidateIns && 'border-danger', warning && 'border-warning']"

      v-bind="attrs"
      v-on="listeners"

      class="form-control"
      aria-describedby="addon-right addon-left"
    ></textarea>
  </BaseFieldWrapper>
</template>

<script>

import BaseFieldWrapper, { props } from "./FormFieldWrapper.vue"

export default {
  props: {
    ...props,

    focus: Boolean,
  },
  components: {
    BaseFieldWrapper,
  },
  mounted() {
    this.focus && this.focusInput()
  },
  methods: {
    focusInput() {
      this.$refs.input.focus()
    },
  },
}

// #6D6E71
// #bebfc1
</script>

<style scope>

textarea {
  border: 1px solid #bebfc1 !important;
}

</style>
